import React from 'react';
import { Page } from 'src/Common/Components/Page';
import { DevicePoolManagementContent } from './Components/DevicePoolManagementContent';

export const DevicePoolManagement = (): React.JSX.Element => (
  <Page title="Device Pools" accessKey={'devicePools'} isSearchable={true}>
    <DevicePoolManagementContent />
  </Page>
);
